// Selecteur de variantes sur carte produit (TABU CBD)
// Tout l'affichage (prix, prix au gramme, remise) est dans les <option>,
// rendues cote Liquid. Le JS ne pilote que le bouton d'ajout : quick-add.js
// lit dataset.variantId au clic, il suffit de le reecrire a chaque changement.

if (!customElements.get('card-variant-picker')) {
  class CardVariantPicker extends HTMLElement {
    connectedCallback() {
      this.select = this.querySelector('[data-ref="cvp-select"]');
      if (!this.select) return;

      this.addButton = this.querySelector('[data-ref="add-to-cart-button"]');
      this.addButtonPrice = this.querySelector('[data-ref="cvp-atc-price"]');

      this.select.addEventListener('change', this.handleChange);

      // La carte est souvent enveloppee dans un lien produit : on empeche
      // le clic sur le select de declencher la navigation.
      this.addEventListener('click', this.stopClick);

      this.handleChange();
    }

    disconnectedCallback() {
      this.select?.removeEventListener('change', this.handleChange);
      this.removeEventListener('click', this.stopClick);
    }

    stopClick = (event) => {
      if (event.target.closest('[data-ref="add-to-cart-button"]')) return;
      event.stopPropagation();
    };

    handleChange = () => {
      const option = this.select.options[this.select.selectedIndex];
      if (!option) return;

      const price = option.dataset.price || '';
      const available = option.dataset.available !== 'false';

      if (this.addButton) {
        this.addButton.dataset.variantId = option.value;
        this.addButton.disabled = !available;
      }

      if (this.addButtonPrice) {
        this.addButtonPrice.textContent = price;
        this.addButtonPrice.hidden = price === '';
      }
    };
  }

  customElements.define('card-variant-picker', CardVariantPicker);
}
